import React from 'react';

import ProtectedData, { getSeverity, UNKNOWN } from 'pages/components/ProtectedData';

import useStyles from './styles';

interface Props {
    label?: string;
    value: number;
    scale?: number;
    className?: string;
}

const Score: React.FC<Props> = ({ value, label, scale, className }) => {
    const { classes, cx } = useStyles();
    const severity = getSeverity(value, scale);

    return (
        <span
            className={cx(
                classes.root,
                {
                    [classes._high]: severity === 'High',
                    [classes._medium]: severity === 'Medium',
                    [classes._low]: severity === 'Low',
                    [classes._unknown]: severity === UNKNOWN
                },
                className
            )}
        >
            <ProtectedData data={value} />
            {label ? <span className={classes.label}>{label}</span> : null}
        </span>
    );
};

export default Score;
